import JorneyToHomeGameSttingBody from "views/j2h/JorneyToHomeGameSettingBody";
import WTBGameSettingBody from "views/wtb/WhosTheBotGameSettingBody";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { GeneralRoomParams } from "module/types";
import RoleDistributorGameSettingBody from "views/roleDistributor/RoleDistributorGameSettingBody";
import DealerJackGameSettingBody from "views/dealerjack/DealerJackGameSettingBody";
import BattleJackGameSettingBody from "views/battlejack/BattleJackGameSettingBody";
import QuizGameSettingBody from "views/quiz/QuizGameSettingBody";

export type GameSettingBaseProps = {
  setGameSetting: Dispatch<SetStateAction<{}>>;
  roomParams: GeneralRoomParams;
  aiCount: number;
};

type GameSettingModalProps = GameSettingBaseProps & {
  isOpen: boolean;
};

function GameSettingModal({
  isOpen,
  setGameSetting,
  roomParams: gameParams,
  aiCount,
}: GameSettingModalProps) {
  const { t } = useTranslation();

  const getBody = () => {
    switch (gameParams.product.id) {
      case 0:
        return (
          <JorneyToHomeGameSttingBody
            setGameSetting={setGameSetting}
            roomParams={gameParams}
            aiCount={aiCount}
          />
        );
      case 1:
        return (
          <WTBGameSettingBody
            setGameSetting={setGameSetting}
            roomParams={gameParams}
            aiCount={aiCount}
          />
        );
      case 2:
        return (
          <RoleDistributorGameSettingBody
            setGameSetting={setGameSetting}
            roomParams={gameParams}
            aiCount={aiCount}
          />
        );
      case 6:
        return (
          <DealerJackGameSettingBody
            setGameSetting={setGameSetting}
            roomParams={gameParams}
            aiCount={aiCount}
          />
        );
      case 7:
        return (
          <QuizGameSettingBody
            setGameSetting={setGameSetting}
            roomParams={gameParams}
            aiCount={aiCount}
          />
        );
      default:
        return <div />;
    }
  };

  return (
    <div
      className={`${
        isOpen ? "right-0" : "right-[-150%]"
      } absolute top-[100%] md:mr-1 md:mt-1 w-full md:w-[50%] md:bg-neutral-800 bg-neutral-800/95 md:rounded-lg shadow-xl z-10 border border-gray-700 text-gray-300 transform transition-all duration-200 ease-in-out flex flex-col`}
      style={{
        maxHeight: "calc(100vh - 120px)", // 화면 높이에서 헤더와 여백 제외
      }}
    >
      {/* Header - Fixed */}
      <div className="flex justify-center items-center mt-2">
        <div className="text-yellow-500 font-semibold">{t("gameSetting")}</div>
      </div>

      {/* Content - Scrollable */}
      <div className="flex-1 overflow-y-auto p-2">{getBody()}</div>
    </div>
  );
}

export default GameSettingModal;
